import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  Renderer2,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CurrencyPipe } from 'src/app/pipes/currency.pipe';
import { BalanceService } from 'src/app/services/balance.service';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

declare var WidgetCheckout;

@Component({
  selector: 'app-wompi',
  templateUrl: './wompi.component.html',
  styleUrls: ['./wompi.component.scss'],
})
export class WompiComponent implements OnDestroy {
  @Input() orderId: string;
  @Input() set amount(value: number) {
    if (value) {
      this._vAmount = value;
      this.getData();
    }
  }
  @Output() vEmitData$ = new EventEmitter<FormData>();
  private _vSuscription?: Subscription = undefined;
  private _vCheckout?: any = undefined;
  private _vAmount = 0;
  private _vScript?: HTMLScriptElement = undefined;

  get vCheckout() {
    return this._vCheckout;
  }

  constructor(
    private renderer: Renderer2,
    private _vHttpSv: HttpService,
    private _vCurrencySv: BalanceService,
    private _vCurrencyPipe: CurrencyPipe
  ) {}

  async getData() {
    const vIntegrity = await this._getIntegrityKey();
    this._insertScript(
      vIntegrity.hashHex,
      vIntegrity.reference,
      vIntegrity.publicKey,
      vIntegrity.amount
    );
  }

  private async _getIntegrityKey() {
    const amount = Number(
      this._vCurrencyPipe.transform(this._vAmount, this._vCurrencySv.currency)
    );
    const params = {
      domainId: environment.domainId,
      orderId: this.orderId,
      amount: amount,
      currency: this._vCurrencySv.currency.symbol,
    };
    const res = await this._vHttpSv.itemIndex('wompi', '', params, 'show');
    return { ...res.data, amount };
  }

  private _insertScript(
    pIntegrity: string,
    pReference: string,
    pPublicKey: string,
    pAmount: number
  ): void {
    const script = document.createElement('script');
    this.renderer.setAttribute(
      script,
      'src',
      'https://checkout.wompi.co/widget.js'
    );

    script.onload = () => {
      this._vCheckout = new WidgetCheckout({
        currency: this._vCurrencySv.currency.symbol,
        amountInCents: pAmount * 100,
        reference: pReference,
        publicKey: pPublicKey,
        signature: {
          integrity: pIntegrity,
        },
      });
    };
    const form = document.getElementById('wompiForm');
    if (this._vScript) {
      this._vCheckout = new WidgetCheckout({
        currency: this._vCurrencySv.currency.symbol,
        amountInCents: pAmount * 100,
        reference: pReference,
        publicKey: pPublicKey,
        signature: {
          integrity: pIntegrity,
        },
      });
    }
    this._vScript = script;
    this.renderer.appendChild(form, script);
  }

  openWompi() {
    this.renderer.addClass(document.body, 'opened-wompi');
    this._vCheckout.open((result) => {
      this.renderer.removeClass(document.body, 'opened-wompi');
      const transaction = result.transaction;
      const formData = new FormData();
      formData.append('reference', transaction.id);
      this.vEmitData$.emit(formData);
    });
  }

  ngOnDestroy(): void {
    this._vSuscription?.unsubscribe();
  }
}
